import React from "react";
import Filter from "../components/Filter";
import Results from "../components/Results";
//console.log("src/containers/FilterContainer.js");
const FilterContainer = () => {
  return (
    <div>
      <Filter />
      <Results />
    </div>
  );
};

export default FilterContainer;
